import { cn } from "@/lib/utils";

interface ScrollableChartProps {
  children: React.ReactNode;
  /** Minimum width (CSS value) to enforce on mobile, triggering horizontal scroll. */
  minWidth?: string;
  className?: string;
}

/**
 * Wrapper that enables horizontal scrolling for charts on mobile devices.
 * On desktop, the container width naturally exceeds minWidth, so no scrolling occurs.
 * On mobile (<~500px viewport), the chart maintains its minWidth and becomes scrollable.
 */
export function ScrollableChart({
  children,
  minWidth = "500px",
  className,
}: ScrollableChartProps): React.ReactElement {
  return (
    <div className={cn("overflow-x-auto -mx-1 px-1 h-full", className)}>
      <div style={{ minWidth, height: "100%" }}>{children}</div>
    </div>
  );
}
